import React from 'react';

import SchoolsSplash from './SchoolsSplash';
import LayoutGrid from '../../components/LayoutGrid';

async function action(context) {
  return {
    component: (
      <LayoutGrid>
        <SchoolsSplash pathname={context.pathname} />
      </LayoutGrid>
    ),
  };
}

export default action;
